"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _ExpertiseComponent2 = _interopRequireDefault(require("./ExpertiseComponent"));

var _BaseExpertiseForm = _interopRequireDefault(require("./BaseExpertiseForm"));

var _Select = _interopRequireDefault(require("../select/Select"));

var _CustomSelectComponent = _interopRequireDefault(require("../select/CustomSelectComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _default = function _default(options) {
  var ScoreSelect =
  /*#__PURE__*/
  function (_ExpertiseComponent) {
    _inherits(ScoreSelect, _ExpertiseComponent);

    function ScoreSelect() {
      _classCallCheck(this, ScoreSelect);

      return _possibleConstructorReturn(this, _getPrototypeOf(ScoreSelect).apply(this, arguments));
    }

    _createClass(ScoreSelect, [{
      key: "getScore",
      value: function getScore() {
        var value = this.dataValue;
        return value ? value : 0;
      }
    }, {
      key: "defaultSchema",
      get: function get() {
        return ScoreSelect.schema();
      }
    }], [{
      key: "schema",
      value: function schema() {
        for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
          extend[_key] = arguments[_key];
        }

        return _Select.default.schema.apply(_Select.default, [{
          type: 'expertiseScoreSelect',
          label: 'Score Select',
          key: 'expertiseScoreSelect',
          data: {
            values: []
          },
          limit: 100,
          dataSrc: 'values',
          valueProperty: '',
          filter: '',
          searchEnabled: true,
          searchField: '',
          minSearch: 0,
          readOnlyValue: false,
          authenticate: false,
          template: '<span>{{ item.label }}</span>',
          selectFields: '',
          searchThreshold: 0.3,
          fuseOptions: {},
          customOptions: {}
        }].concat(extend));
      }
    }, {
      key: "editForm",
      value: function editForm() {
        for (var _len2 = arguments.length, extend = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          extend[_key2] = arguments[_key2];
        }

        return _BaseExpertiseForm.default.apply(void 0, [[{
          key: 'data',
          components: _editForm
        }, {
          label: 'Expertise',
          key: 'expertise',
          weight: 15,
          components: [{
            type: 'number',
            input: true,
            weight: 10,
            key: 'weight',
            label: 'Вес',
            validate: {
              required: true
            }
          }]
        }]].concat(extend));
      }
    }, {
      key: "builderInfo",
      get: function get() {
        return {
          title: 'Score Select',
          icon: 'fa fa-plus-square',
          group: 'expertise',
          weight: 70,
          schema: ScoreSelect.schema()
        };
      }
    }]);

    return ScoreSelect;
  }((0, _ExpertiseComponent2.default)((0, _CustomSelectComponent.default)(options)));

  return ScoreSelect;
};

exports.default = _default;
var _editForm = [{
  type: 'select',
  input: true,
  weight: 0,
  key: 'dataSrc',
  defaultValue: 'values',
  label: 'Источник значений',
  dataSrc: 'values',
  searchEnabled: false,
  data: {
    values: [{
      label: 'Ввести руками',
      value: 'values'
    }, {
      label: 'Форма',
      value: 'custom'
    }]
  }
}, // dataSrc === values
{
  type: 'datagrid',
  input: true,
  label: 'Значения для Score Select',
  key: 'data.values',
  weight: 1,
  reorder: true,
  components: [{
    label: 'Значение',
    key: 'label',
    input: true,
    type: 'textfield'
  }, {
    label: 'Код в бд',
    key: 'value',
    input: true,
    type: 'number'
  }],
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'values']
    }
  }
}, // dataSrc === custom
{
  type: 'textarea',
  input: true,
  key: 'data.custom',
  label: 'Js-код, преобразующий данные формы которую заполняет пользователь в массив элементов справочника',
  editor: 'ace',
  rows: 10,
  weight: 1,
  placeholder: "Например: values = data['mykey'];",
  tooltip: 'Данные формы доступны в объекте data. Не забудьте записать результирующий массив в переменную values.',
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'custom']
    }
  }
}, {
  type: 'textfield',
  input: true,
  label: 'Value Property',
  key: 'valueProperty',
  skipMerge: true,
  clearOnHide: false,
  weight: 2,
  tooltip: 'Поле элемента справочника, которое будет храниться в БД'
}, {
  type: 'textarea',
  input: true,
  key: 'template',
  label: 'Шаблон айтема',
  editor: 'ace',
  as: 'html',
  rows: 3,
  weight: 18,
  tooltip: 'HTML'
}, {
  type: 'checkbox',
  input: true,
  weight: 4,
  key: 'searchEnabled',
  label: 'Поиск на клиенте',
  defaultValue: true
}, {
  type: 'textarea',
  as: 'json',
  editor: 'ace',
  weight: 5,
  input: true,
  key: 'customOptions',
  label: 'Параметры выпадающего списка',
  tooltip: 'Полный список доступных параметров смотрите в Select.js:choicesOptions',
  placeholder: '{\n' + '"noResultsText": "Пусто",\n' + '"searchPlaceholderValue": "Найти"\n' + '}'
}];